import { useState } from 'react'
import { calcDV, getPilaDiaHabil } from '../data/fechas2026'
import styles from '../CalendarioTributario.module.css'

export default function BuscadorNIT({ onBuscar }) {
    const [nit, setNit]         = useState('')
    const [regimen, setRegimen] = useState('bim')
    const [municipio, setMunicipio] = useState('ninguno')
    const [dv, setDv]           = useState(null)
    const [info, setInfo]       = useState(null)

    function handleNitChange(val) {
        const clean = val.replace(/\D/g, '')
        setNit(clean)
        if (clean.length >= 6) {
            const dvCalc = calcDV(clean)
            setDv(dvCalc)
            const dig  = parseInt(clean[clean.length-1])
            const dh   = getPilaDiaHabil(clean)
            setInfo({ dig, dosDig: clean.slice(-2), dh, dvCalc })
        } else {
            setDv(null)
            setInfo(null)
        }
    }

    function handleBuscar() {
        if (nit.length < 6) {
            alert('Por favor ingresa un NIT válido (mínimo 6 dígitos).')
            return
        }
        onBuscar(nit, regimen, municipio)
    }

    return (
        <div className={styles.searchSection}>
            <div className={styles.searchInner}>
                <div className={styles.searchLabel}>🔍 Consulta tu calendario tributario personalizado</div>
                <div className={styles.searchRow}>
                    {/* NIT */}
                    <div className={`${styles.fieldWrap} ${styles.nitField}`}>
                        <label>NIT de la empresa</label>
                        <div className={styles.nitInner}>
                            <input
                                type="text"
                                placeholder="Ej: 900787251"
                                maxLength={12}
                                value={nit}
                                onChange={e => handleNitChange(e.target.value)}
                                onKeyDown={e => e.key === 'Enter' && handleBuscar()}
                                className={styles.nitInput}
                            />
                            {dv !== null && (
                                <span className={styles.nitDv}>-{dv}</span>
                            )}
                        </div>
                    </div>

                    {/* Régimen IVA */}
                    <div className={`${styles.fieldWrap} ${styles.regField}`}>
                        <label>Régimen de IVA</label>
                        <select value={regimen} onChange={e => setRegimen(e.target.value)} className={styles.select}>
                            <option value="bim">Bimestral (ingresos &gt; 92.000 UVT)</option>
                            <option value="cuat">Cuatrimestral (ingresos 15.000–92.000 UVT)</option>
                            <option value="anual">Anual (ingresos &lt; 15.000 UVT)</option>
                        </select>
                    </div>

                    {/* Municipio */}
                    <div className={`${styles.fieldWrap} ${styles.munField}`}>
                        <label>Municipio adicional</label>
                        <select value={municipio} onChange={e => setMunicipio(e.target.value)} className={styles.select}>
                            <option value="ninguno">— Sin municipio adicional —</option>
                            <option value="bogota">Bogotá (ICA + ReteICA)</option>
                        </select>
                    </div>

                    {/* Botón */}
                    <div className={styles.fieldWrap}>
                        <label>&nbsp;</label>
                        <button className={styles.btnBuscar} onClick={handleBuscar}>
                            Ver Vencimientos →
                        </button>
                    </div>
                </div>

                {info && (
                    <div className={styles.nitInfo}>
                        <strong>Dígito verificación: {info.dvCalc}</strong>
                        &nbsp;·&nbsp; Último dígito DIAN: <strong>{info.dig}</strong>
                        &nbsp;·&nbsp; 2 últimos dígitos PILA: <strong>{info.dosDig}</strong> → día hábil <strong>{info.dh}</strong>
                    </div>
                )}
            </div>
        </div>
    )
}
